var map = {
	"./affiliate-center/deposit/index.vue": "a538",
	"./affiliate-center/transfer/index.vue": "ad99",
	"./dy/login/index.vue": "221f",
	"./dy/register/index.vue": "82d5",
	"./home/index.vue": "7abe",
	"./login/index.vue": "9ed6",
	"./my/login/index.vue": "808d",
	"./my/register/index.vue": "5640",
	"./personal/index.vue": "972a",
	"./ph/login/index.vue": "16ee",
	"./ph/register/index.vue": "b3da",
	"./referral/affiliate-domain/index.vue": "1d29",
	"./referral/referral-link/index.vue": "0922",
	"./settlement/index.vue": "876f",
	"./statistics/affiliate-daily-report/index.vue": "8088",
	"./statistics/game/affiliate/index.vue": "7f75",
	"./statistics/game/index.vue": "8caa",
	"./statistics/game/member/index.vue": "f65d",
	"./team/affiliate/index.vue": "1a92",
	"./team/bet-record/index.vue": "4df8",
	"./team/deposit-record/index.vue": "2072",
	"./team/member/index.vue": "93ba",
	"./th/login/index.vue": "8b11",
	"./th/register/index.vue": "ac37",
	"./xf/login/index.vue": "3324",
	"./xf/register/index.vue": "74bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "76fe";